<template>
  <div class="mt-0">

    <!-- testmode: start -->
    <div v-if="workshop.testmode">

      <svg v-if="workshop.analysis_ordered_at"
        v-tooltip.top="`Bestellt am ${this.$options.filters.formatDate(workshop.analysis_ordered_at)}`"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-red text-markencode-red opacity-50">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
      </svg>

      <!-- end testmode: start -->
      <button v-else @click="endWorkshopTestmode" class="text-gray-500  hover:text-markencode-blue outline-none">

        <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 mt-1 outline-none fill-markencode-yellow animate-pulse text-markencode-yellow">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
      </svg>

      </button>
      <!-- end testmode: end -->


    </div>
    <!-- testmode: end -->

    <div v-else>

      <!-- continue/stop workshop: start -->
      <button v-if="!workshop.analysis_ordered_at && !workshop.completed_at" @click="toggleWorkshop(workshop)"
        class="text-gray-500  hover:text-markencode-blue outline-none">

        <!-- continue workshop: start -->
        <svg v-if="workshop.activated_at == null" v-tooltip.top="'Starten'" xmlns="http://www.w3.org/2000/svg"
          fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 mt-1 outline-none fill-markencode-red text-markencode-red">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
        </svg>
        <!-- continue workshop: end -->



        <svg v-else v-tooltip.top="'Stoppen'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke-width="1.5" stroke="currentColor"
          class="w-6 h-6 outline-none mt-1 fill-markencode-green animate-pulse text-markencode-green">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z" />
        </svg>
      </button>
      <!-- continue/stop workshop: end -->



      <!-- already ordered: start -->
      <svg v-if="workshop.analysis_ordered_at"
        v-tooltip.top="`Bestellt am ${this.$options.filters.formatDate(workshop.analysis_ordered_at)}`"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-red text-markencode-red opacity-50">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
      </svg>
      <!-- already ordered: end -->


      <!-- already completed: start -->
      <svg v-else-if="workshop.completed_at"
        v-tooltip.top="`Abgeschlossen am ${this.$options.filters.formatDate(workshop.completed_at)}`"
        xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-6 h-6 outline-none fill-markencode-red text-markencode-red opacity-50">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M5.25 7.5A2.25 2.25 0 0 1 7.5 5.25h9a2.25 2.25 0 0 1 2.25 2.25v9a2.25 2.25 0 0 1-2.25 2.25h-9a2.25 2.25 0 0 1-2.25-2.25v-9Z" />
      </svg>
      <!-- already completed: end -->

    </div>

    <confirm-modal v-if="confirmModal.visible" @close="confirmModal.visible = false"
      @confirm="endWorkshopTestmodeConfirmed" class="z-[200]"></confirm-modal>

  </div>
</template>

<script>
import ConfirmModal from '@/Pages/ControlPanel/Workshops/Shared/WorkshopTestmodeConfirmModal.vue';

export default {
  components: {
    ConfirmModal,
  },

  props: {
    workshop: {
      type: Object,
      required: false,
      default: () => { },
    },

  },

  data() {
    return {
      confirmModal: {
        visible: false,
      },
    };
  },

  methods: {
    toggleWorkshop(workshop) {
      this.$inertia.post(this.route('control-panel.workshops.toggle', { sessionUuid: workshop.uuid, }), {}, {
        preserveScroll: true,
        preserveState: false,
      });
    },

    endWorkshopTestmode() {
      this.confirmModal.visible = true;
    },

    endWorkshopTestmodeConfirmed() {

      this.confirmModal.visible = false;

      this.$inertia.post(this.route('control-panel.workshops.workshops.end-testmode', { sessionUuid: this.workshop.uuid, }), {

      }, {
        preserveScroll: true,
        preserveState: false,
      });

    },
  },
};
</script>